import React, { FC, ReactElement } from 'react';
import cns from 'classnames';
import './Prefooter.sass';
import { useSelector } from 'react-redux';
import { getContentDataContacts } from '../../../../stores/reducers/userData';

interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;
}

const Prefooter: FC<Props> = ({ className, bgSettings, sectionName, sectionId }): ReactElement => {
  const contacts = useSelector(getContentDataContacts);
  return (
    <section
      className={cns(
        'inner-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        'section-contacts',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="container" id={sectionId}>
        <div className="inner-section__head">
          <div className="section-title">{sectionName}</div>
        </div>
        <div className="contacts-bl">
          <div className="contact-item">
            <a className="contact-item__email" href="mailto:email@email.ru">
              {contacts?.email}
            </a>
          </div>
          <div className="contact-item">
            <a className="contact-item__phone" href="tel:+7 889 889 88 87">
              {contacts?.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prefooter;
